import React, {useState} from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import './App.css';
import logo from './assets/logo.svg';
import Header from './pages/header';

import Routes from './routes';
import FirebaseService from './services/firebase';

function App() {
  // const location = useLocation();
  const [user, setUser] = useState({});

  FirebaseService.currentUser.subscribe(data => {
    if (user?.uid != data?.uid) {
      setUser(data);
    }
  })
  
  return (
    <>
      <BrowserRouter>
        {!(user?.isAnonymous) && <Header/>}
        <div className="container">
          {/* <img src={logo} alt="logo"/> */}
          <div className="content">
            <Routes />
          </div>
        </div>
      </BrowserRouter>
    </>
  );
}

export default App;
